import React from 'react';
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianAxis
} from 'recharts';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import { COLORS } from '../../../../constants/color';

function SimpleComposedChart(props) {

  const { data, activeDateRangeToken, activeTokenTab } = props;

  // 시간에 대해 오름차순으로 데이터 정렬
  const sortedData = data && data.sort((a, b) => new Date(a.time) - new Date(b.time));

  const dataKeys = Object.keys(sortedData.length > 1 && sortedData[0]).filter(key => (key !== 'time' && key !== '총 스펜딩 수'));

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ResponsiveContainer>

        {sortedData.length > 0 ?
          <ComposedChart data={sortedData}>
            <XAxis dataKey="time" tickLine={false} tickFormatter={(time) => timeFormAPI.changeDataDate(time)}/>
            <YAxis axisLine={false} tickSize={3} tickLine={false} tick={{ stroke: 'none' }}/>
            <CartesianGrid vertical={false} strokeDasharray="3 3"/>
            <CartesianAxis vertical={false}/>
            <Tooltip />
            <Legend iconType="circle" verticalAlign="bottom" iconSize={10}/>

            {/* Line for '총 스펜딩 수' */}
            <Line
              key="총 스펜딩 수"
              type="monotone"
              dataKey="총 스펜딩 수"
              strokeWidth={2}
              stroke={COLORS['총 스펜딩 수'] || `#${Math.floor(Math.random() * 16777215).toString(16)}`}
              dot={{ r: 3 }}
              name="총 스펜딩 수"
              legendType={'square'}
            />

            {dataKeys.map((filteredKey, index) => (
              // Bar for others
              <Bar
                key={index}
                dataKey={filteredKey}
                barSize={10}
                fill={COLORS[filteredKey] || `#${Math.floor(Math.random() * 16777215).toString(16)}`}
                name={filteredKey}
                legendType={'square'}
              />
            ))}
          </ComposedChart>
          : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', backgroundColor: '#FAFBFC' }}>
            해당 기간의 데이터 없음
          </div>
        }

      </ResponsiveContainer>
    </div>
  );
}

export default SimpleComposedChart;
